import React from "react";

function ProjectIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 57.222 53.465">
      <g id="Groupe_5060" transform="translate(-1330.46 -100)">
        <g id="folder" transform="translate(1330.46 100)">
          <g id="Groupe_1870" transform="translate(0 0)">
            <path
              id="Tracé_2938"
              d="M42.813,46.881H27.358a2.335,2.335,0,0,1-1.663-.7l-4.822-5.08a6.111,6.111,0,0,0-4.351-1.75H6.016A6.023,6.023,0,0,0,0,45.372v29.29a6.023,6.023,0,0,0,6.016,6.016H42.84a6.022,6.022,0,0,0,5.989-6.035V52.9A6.023,6.023,0,0,0,42.813,46.881Zm2.337,27.77A2.338,2.338,0,0,1,42.831,77H6.016A2.34,2.34,0,0,1,3.68,74.662V45.372a2.343,2.343,0,0,1,2.337-2.338H16.63a2.321,2.321,0,0,1,1.612.642l4.8,5.056a6.045,6.045,0,0,0,4.32,1.829H42.813A2.34,2.34,0,0,1,45.149,52.9V74.651Z"
              transform="translate(0 -39.356)"
              fill="#1f292d"
            />
          </g>
        </g>
        <g id="Icon_feather-clock" transform="translate(1354.876 120.658)">
          <path
            id="Tracé_3546"
            d="M34.307,18.653A15.653,15.653,0,1,1,18.653,3,15.653,15.653,0,0,1,34.307,18.653Z"
            transform="translate(-3 -3)"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="3"
          />
          <path
            id="Tracé_3547"
            d="M18,9v9.392l6.261,3.131"
            transform="translate(-3.41 -2.739)"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="3"
          />
        </g>
      </g>
    </svg>
  );
}

export { ProjectIcon };
